import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Services
export const getServices = async () => {
  try {
    const response = await axios.get(`${API}/services`);
    return response.data;
  } catch (error) {
    console.error('Error fetching services:', error);
    return [];
  }
};

// Gallery
export const getGallery = async () => {
  try {
    const response = await axios.get(`${API}/gallery`);
    return response.data;
  } catch (error) {
    console.error('Error fetching gallery:', error);
    return [];
  }
};

// Special Offers
export const getOffers = async () => {
  try {
    const response = await axios.get(`${API}/offers`);
    return response.data;
  } catch (error) {
    console.error('Error fetching offers:', error);
    return [];
  }
};

// Forfaits
export const getForfaits = async () => {
  try {
    const response = await axios.get(`${API}/forfaits`);
    return response.data;
  } catch (error) {
    console.error('Error fetching forfaits:', error);
    return [];
  }
};

// Page Content
export const getPageContent = async (pageName) => {
  try {
    const response = await axios.get(`${API}/content/${pageName}`);
    return response.data.content || {};
  } catch (error) {
    console.error(`Error fetching page content for ${pageName}:`, error);
    return {};
  }
};

// Admin Services
export const adminCreateService = async (service, token) => {
  const response = await axios.post(`${API}/admin/services`, service, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const adminUpdateService = async (serviceId, service, token) => {
  const response = await axios.put(`${API}/admin/services/${serviceId}`, service, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const adminDeleteService = async (serviceId, token) => {
  const response = await axios.delete(`${API}/admin/services/${serviceId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Admin Gallery
export const adminCreateGalleryItem = async (item, token) => {
  const response = await axios.post(`${API}/admin/gallery`, item, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const adminUpdateGalleryItem = async (itemId, item, token) => {
  const response = await axios.put(`${API}/admin/gallery/${itemId}`, item, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const adminDeleteGalleryItem = async (itemId, token) => {
  const response = await axios.delete(`${API}/admin/gallery/${itemId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Admin Offers
export const adminCreateOffer = async (offer, token) => {
  const response = await axios.post(`${API}/admin/offers`, offer, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const adminUpdateOffer = async (offerId, offer, token) => {
  const response = await axios.put(`${API}/admin/offers/${offerId}`, offer, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const adminDeleteOffer = async (offerId, token) => {
  const response = await axios.delete(`${API}/admin/offers/${offerId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Admin Forfaits
export const adminCreateForfait = async (forfait, token) => {
  const response = await axios.post(`${API}/admin/forfaits`, forfait, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const adminUpdateForfait = async (forfaitId, forfait, token) => {
  const response = await axios.put(`${API}/admin/forfaits/${forfaitId}`, forfait, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const adminDeleteForfait = async (forfaitId, token) => {
  const response = await axios.delete(`${API}/admin/forfaits/${forfaitId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export default {
  getServices,
  getGallery,
  getOffers,
  getForfaits,
  getPageContent,
  adminCreateService,
  adminUpdateService,
  adminDeleteService,
  adminCreateGalleryItem,
  adminUpdateGalleryItem,
  adminDeleteGalleryItem,
  adminCreateOffer,
  adminUpdateOffer,
  adminDeleteOffer,
  adminCreateForfait,
  adminUpdateForfait,
  adminDeleteForfait
};
